import { defineMessages } from 'react-intl';
export default defineMessages({
    batteryLevel: {
        id: 'devices.batteryLevel',
        defaultMessage: 'Battery level'
    },
    firmwareVersion: {
        id: 'devices.firmwareVersion',
        defaultMessage: 'Firmware version'
    },
    moduleCount: {
        id: 'devices.moduleCount',
        defaultMessage: '{count, plural, one {# module} other {# modules}}'
    },
    moduleType: {
        id: 'devices.moduleType',
        defaultMessage: 'Module type'
    },
    noNetatmoWeatherStationYet: {
        id: 'devices.noNetatmoWeatherStationYet',
        defaultMessage: "You don't have a Netatmo weather station yet."
    },
    noOutdoorModule: {
        id: 'devices.noOutdoorModule',
        defaultMessage: 'There is no functional outdoor module for this station.'
    },
    notReachable: {
        id: 'devices.notReachable',
        defaultMessage: 'Not reachable'
    },
    serialNumber: {
        id: 'devices.serialNumber',
        defaultMessage: 'Serial number'
    },
    /*
     * The radio/Wi-Fi quality scale.
     *
     * Deliberately NOT `common.good` / `common.average` / `common.bad`. Those
     * were shared with the statistics screens, where `average` correctly means
     * the arithmetic mean — and 13 of the 25 locales had translated it that way
     * (de "Durchschnitt", el "Μέσος όρος", bg "Средни стойности"), so the signal
     * indicator was reading "mean" rather than "middling". Five more disagreed
     * in gender with the adjectives either side of them.
     *
     * English says Fair/Poor rather than Average/Bad for the same reason: they
     * are unambiguously quality words, so no translator has to guess.
     */
    signalAverage: {
        id: 'devices.signalAverage',
        defaultMessage: 'Fair'
    },
    signalBad: {
        id: 'devices.signalBad',
        defaultMessage: 'Poor'
    },
    signalGood: {
        id: 'devices.signalGood',
        defaultMessage: 'Good'
    },
    signalStrength: {
        id: 'devices.signalStrength',
        defaultMessage: 'Signal strength'
    },
    signalUnknown: {
        id: 'devices.signalUnknown',
        defaultMessage: 'Unknown'
    },
    visitNetatmoWebsite: {
        id: 'devices.visitNetatmoWebsite',
        defaultMessage: 'Visit Netatmo website'
    },
    wifiStrength: {
        id: 'devices.wifiStrength',
        defaultMessage: 'Wi-Fi strength'
    }
});
